export default __webpack_public_path__ + "static/media/email-illustration.42b6eed1.svg";